const MS = 1
const SECOND_MS = 1000 * MS
const MINUTE_MS = 60 * SECOND_MS

export const THREE_MINUTES = 3 * MINUTE_MS
